import { render, staticRenderFns } from "./journal-modal.vue?vue&type=template&id=46c0c49e&scoped=true"
import script from "./journal-modal.vue?vue&type=script&lang=ts"
export * from "./journal-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c0c49e",
  null
  
)

export default component.exports